RivalIQ.module('apps', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    const app = apps.Discovery = window.createMarionetteApp();
    app.name = 'Discovery';

});
